
import * as Payment from 'payment';
export * from './ngxcreditcard.module';
export * from './validators/CreditCard.validator';
